/** Pendant zu `Services/API/ApiConfigService.cs`. */

import type { ChinaAppSysConfig } from '@/types/entities';

import { createCrudApi, type CrudApi } from '../apiBase';

export const configApi: CrudApi<ChinaAppSysConfig> = createCrudApi<ChinaAppSysConfig>('config');
